export const getRolePaymentRate = (payment: number) => {
  if (payment >= 800) return 0.2;
  return 0.1;
};

export const calcRolePayment = (payment: number) => {
  return Math.ceil(payment * (1 - getRolePaymentRate(payment)));
};
